<template>
  <div class="form-success-page">
    <v-container class="fill-height">
      <v-row align="center" justify="center">
        <v-col cols="12" md="6">
          <v-card class="pa-6 text-center">
            <v-card-text>
              <v-icon size="80" color="success" class="mb-4">mdi-check-circle</v-icon>
              <h1 class="text-h4 mb-4">Form Submitted Successfully!</h1>
              <p class="mb-6 text--secondary">
                Thank you for completing the form. Your responses have been recorded.
              </p>
              <div class="d-flex justify-center">
                <v-btn color="primary" @click="goBack" large class="mr-4">
                  <v-icon left>mdi-arrow-left</v-icon>
                  Back to Form
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'FormSuccessPage',
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.form-success-page {
  background-color: #f5f5f5;
  min-height: 100vh;
}
</style>
